export default __webpack_public_path__ + "static/media/track-em-all.b229632b.svg";